import { wrapFunctionalComponent } from 'utils/framework';
import {
    Box, Text, Flex, Link, Image
} from 'components/ui';

const RedemptionInfoSection = ({
    image,
    title,
    description,
    link,
    redemptionValue
    // , pointsColor='black'
}) => {
    return (
        <Flex
            marginTop={3}
            direction='row'
            alignItems='flex-start'
            justifyContent='space-between'
            gap={16}
        >
            {/* <ProductImage/> */}
            <Image
                display='inline-block'
                size={32}
                src={image}
            />
            <Flex
                flexDirection='column'
                alignItems='stretch'
            >
                {title && (
                    <Text
                        is='p'
                        fontWeight='bold'
                        children={title}
                    />
                )}
                {description && (
                    <Text
                        is='p'
                        children={description}
                    />
                )}
                {link && (
                    <Link
                        color='blue'
                        href={link.url}
                        children={link.text}
                    />
                )}
            </Flex>
            <Box
                display='flex'
                flexDirection='row'
                justifyContent='flex-end'
                flex={1}
            >
                <Text
                    is='p'
                    children={redemptionValue}
                    // color={pointsColor}
                />
            </Box>
        </Flex>
    );
};

export default wrapFunctionalComponent(RedemptionInfoSection, 'RedemptionInfoSection');
